import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    component: String
  }

  connect() {
    if (this.componentValue === 'dropdown')
      HSDropdown.autoInit();
    if (this.componentValue === 'toast')
      HSRemoveElement.autoInit();
  }
}

